import React from 'react';
import styles from './minimized-player.module.css';

/** Простые inline-SVG иконки */
const Icon = ({ name, className }) => {
  const p = { className: className || styles.icon, viewBox: '0 0 24 24', fill: 'currentColor' };
  switch (name) {
    case 'play':  return <svg {...p}><polygon points="8,5 8,19 19,12" /></svg>;
    case 'pause': return <svg {...p}><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>;
    case 'prev':  return <svg {...p}><rect x="5" y="5" width="2" height="14"/><polygon points="19,5 9,12 19,19"/></svg>;
    case 'next':  return <svg {...p}><rect x="17" y="5" width="2" height="14"/><polygon points="5,5 15,12 5,19"/></svg>;
    case 'maximize':
      return <svg {...p}><path d="M9 5H5v4H3V3h6v2zM15 5h4v4h2V3h-6v2zM9 19H5v-4H3v6h6v-2zM19 15v4h-4v2h6v-6h-2z"/></svg>;
    default: return null;
  }
};

export function MinimizedPlayer({
  currentTrack,
  isPlaying,
  isLoading,
  error,
  progress,
  onTogglePlayPause,
  onNext,
  onPrevious,
  onSeek,
  onToggleMaximize
}) {
  if (error) {
    return (
      <div className={styles.errorBar}>
        <div className={styles.errorLeft}>
          <div className={styles.errorBadge}>!</div>
          <div className={styles.errorTextWrap}>
            <div className={styles.errorTitle}>Playback Error</div>
            <div className={styles.errorSub} title={error}>{error}</div>
          </div>
        </div>
        <button onClick={onToggleMaximize} className={styles.iconBtn} aria-label="Maximize player">
          <Icon name="maximize" />
        </button>
      </div>
    );
  }

  const handleProgressClick = (e) => {
    if (!onSeek) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const percentage = ((e.clientX - rect.left) / rect.width) * 100;
    onSeek(Math.max(0, Math.min(100, percentage)));
  };

  // Если трек ещё не выбран — безопасный плейсхолдер без обращений к полям currentTrack
  if (!currentTrack) {
    return (
      <div className={styles.bar}>
        <div className={styles.progress} />
        <div className={styles.inner}>
          <div className={styles.trackInfo}>
            <div className={styles.cover}>
              <span className={styles.coverNote}>♪</span>
            </div>
            <div className={styles.meta}>
              <div className={styles.title}>No track selected</div>
              <div className={styles.artist}>Pick a beat to start</div>
            </div>
          </div>

          <div className={styles.controls}>
            <button onClick={onPrevious} className={styles.iconBtn} aria-label="Previous">
              <Icon name="prev" />
            </button>

            <button
              onClick={onTogglePlayPause}
              className={styles.playBtn}
              aria-label="Play"
            >
              <Icon name="play" />
            </button>

            <button onClick={onNext} className={styles.iconBtn} aria-label="Next">
              <Icon name="next" />
            </button>

            <button onClick={onToggleMaximize} className={`${styles.iconBtn} ${styles.ml}`} aria-label="Maximize">
              <Icon name="maximize" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.bar}>
      <div className={styles.progress} onClick={handleProgressClick}>
        <div className={styles.progressFill} style={{ width: `${progress || 0}%` }} />
      </div>

      <div className={styles.inner}>
        <div className={styles.trackInfo}>
          <div
            className={styles.cover}
            style={{ backgroundImage: currentTrack?.cover ? `url(${currentTrack.cover})` : 'none' }}
          >
            {!currentTrack?.cover && <span className={styles.coverNote}>♪</span>}
          </div>
          <div className={styles.meta}>
            <div className={styles.title} title={currentTrack?.title || ''}>{currentTrack?.title || ''}</div>
            <div className={styles.artist} title={currentTrack?.artist || ''}>{currentTrack?.artist || ''}</div>
          </div>
        </div>

        <div className={styles.controls}>
          <button onClick={onPrevious} className={styles.iconBtn} aria-label="Previous">
            <Icon name="prev" />
          </button>

          <button
            onClick={onTogglePlayPause}
            disabled={isLoading}
            className={styles.playBtn}
            aria-label={isPlaying ? 'Pause' : 'Play'}
          >
            {isLoading ? <span className={styles.spinner} /> : isPlaying ? <Icon name="pause" /> : <Icon name="play" />}
          </button>

          <button onClick={onNext} className={styles.iconBtn} aria-label="Next">
            <Icon name="next" />
          </button>

          <button onClick={onToggleMaximize} className={`${styles.iconBtn} ${styles.ml}`} aria-label="Maximize">
            <Icon name="maximize" />
          </button>
        </div>
      </div>
    </div>
  );
}


